function getShortLanguageId(lang) {
	return lang.split('_').shift();
}

// Angular Seed Config
window.$config = {
	lang: getShortLanguageId(Liferay.ThemeDisplay.getLanguageId()),
	langs: Object.keys(Liferay.Language.available).map(getShortLanguageId),
	basePath: '/',
	apiContext: '/api',
	currentTime: new Date().toISOString().slice(0, -5),
	theme: 'default',
	custom: 'default',
	prodMode: true,
	pingTimeout: 300,
	idleTimeout: 720,
	useHash: true,
	cdsAppearance: 'shadow',
};
